<template>
  <!-- 辅料详情：展示辅料基础信息、已标识商品、库存统计、预估自动消耗记录和注意事项 -->
  <div class="material-detail-root">
    <detailHeader />
    <div class="material-detail-page" v-loading="loading">
      <!-- 基础信息：主图、名称、详情图、资料文件 -->
      <div class="section info-section">
        <div class="info-body">
          <div class="material">
            <div class="section-title">{{ $t('message.materialInfo') }}</div>
            <div class="material-left">
              <!-- 主图：有图时支持放大预览和单独替换；无图时展示上传入口 -->
              <div class="main-image">
                <div v-if="detail.main_image" class="media-item main-media" v-loading="mediaLoading">
                  <el-image :src="detail.main_image" fit="cover" :preview-src-list="[detail.main_image]" />
                  <div class="main-image-mask">
                    <!-- <span class="main-image-btn" @click.stop="mainImagePreviewVisible = true">
                      <i class="el-icon-zoom-in"></i>
                    </span> -->
                    <el-upload class="main-change-upload" action="#" :http-request="uploadMainImage"
                      :before-upload="beforeImageUpload" :show-file-list="false">
                      <span class="main-image-btn">
                        <i class="el-icon-edit-outline"></i>
                      </span>
                    </el-upload>
                  </div>
                </div>
                <el-upload v-else action="#" :http-request="uploadMainImage" :before-upload="beforeImageUpload"
                  :show-file-list="false">
                  <div class="upload-card main-upload" v-loading="mediaLoading">
                    <i class="el-icon-plus"></i>
                    <p>{{ $t('message.uploadMainImage') }}</p>
                  </div>
                </el-upload>
              </div>

              <div class="material-info">
                <!-- 辅料名称区：类型标签、名称、译文，编辑图标只修改名称字段 -->
                <div class="name-row">
                  <span class="type-tag">{{ detail.type_name || (detail.type && detail.type.name) || '-' }}</span>
                  <span class="name">{{ detail.name || '-' }}</span>
                  <span class="name-trans">{{ detail.name_trans || '-' }}</span>
                  <i class="el-icon-edit-outline name-edit-icon" @click="openNameDialog"></i>
                </div>
                <!-- 客户信息与默认消耗：默认消耗用于已标识商品未单独设置消耗时兜底展示 -->
                <div class="sub-row">
                  <span>{{ $t('message.clientID') }}：{{ detail.user_id || '-' }}</span>
                  <span>{{ $t('message.userName') }}：{{ (detail.user && detail.user.realname) || detail.realname || '-'
                    }}</span>
                  <span>{{ $t('message.defaultConsumption') }}：{{ detail.consume || 0 }} {{ $t('message.pointsPerSet')
                    }}</span>
                </div>

                <!-- 详情图：可单独增删；每次变化后立即保存完整 images 数组 -->
                <div class="image-list">
                  <div class="thumb media-item" v-for="(item, index) in images" :key="item + index">
                    <el-image :src="item" fit="cover" :preview-src-list="images" />
                    <i class="el-icon-error delete-icon" @click="removeImage(index)"></i>
                  </div>
                  <el-upload action="#" :http-request="uploadImages" :before-upload="beforeImageUpload"
                    :show-file-list="false">
                    <div class="upload-card thumb-upload" v-loading="mediaLoading">
                      <i class="el-icon-plus"></i>
                      <p>{{ $t('message.uoloadPic') }}</p>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>

          </div>
          <!-- 资料文件：可单独增删；文件名从 OSS 地址中解析，完整地址用于下载/预览 -->
          <div class="file-area">
            <div class="section-title">{{ $t('message.materialDocumentFiles') }}</div>
            <div class="file-list">
              <div v-for="(item, index) in files" :key="item + index" class="file-card">
                <a :href="item" target="_blank">
                  <i class="el-icon-document"></i>
                  <span :title="getFileName(item)">{{ getFileName(item) }}</span>
                </a>
                <i class="el-icon-error delete-icon" @click="removeFile(index)"></i>
              </div>
              <el-upload action="#" :http-request="uploadFiles" :show-file-list="false">
                <div class="upload-card file-upload" v-loading="mediaLoading">
                  <i class="el-icon-plus"></i>
                  <p>{{ $t('message.uploadFiles') }}</p>
                </div>
              </el-upload>
            </div>
          </div>

          <!-- 已绑定的商品管理番号及下单方案：按管理番号分页，方案明细在固定高度区域内滚动展示 -->
          <div class="bound-order-plan-area">
            <div class="bound-order-plan-header">
              <!-- $t('message.boundOrderPlanList')：标题“绑定商品管理番号”。 -->
              <div class="section-title">{{ $t('message.boundOrderPlanList') }}</div>
              <!-- $t 从 message 多语言字典读取按钮文案；点击后打开批量绑定候选弹框。 -->
              <el-button type="primary" size="mini" @click="openBatchBindOrderPlanDialog" v-if="isAuth(757)">{{
                $t('message.batchBind') }}</el-button>
            </div>
            <div class="bound-order-plan-table">
              <el-table v-loading="boundOrderPlanLoading" :data="boundOrderPlanList"
                :header-cell-style="{ background: '#EDEFF4' }" border height="180">
                <el-table-column :label="$t('message.productManagementNumber')" align="center" width="130">
                  <template slot-scope="scope">
                    <a href="#" class="a-link" @click.prevent="openBoundProduct(scope.row)">
                      {{ scope.row.client_sku_code }}
                    </a>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('message.orderPlan')" align="left" min-width="220">
                  <template slot-scope="scope">
                    <div v-if="scope.row.plans && scope.row.plans.length" class="bound-plan-lines">
                      <div v-for="plan in scope.row.plans" :key="plan.plan_id"
                        class="bound-plan-line">
                        <span>{{ plan.name }}</span>
                        <span class="bound-plan-consume">
                          <span>{{ $t('message.materialConsumption') }}：</span>
                          <!-- materials 为空时不读 [0]，避免渲染报错 -->
                          <span class="bound-plan-consume-value">{{ plan.consume }}</span>
                          <span> {{ $t('message.pointsPerSet') }}</span>
                        </span>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- 已标识商品列表：展示已绑定该辅料的商详商品，并可跳转订单详情 -->
      <div class="section">
        <div class="section-title">{{ $t('message.markedProductList') }}</div>
        <div class="border"></div>
        <el-table v-loading="orderLoading" :data="orderList" :header-cell-style="{ background: '#EDEFF4' }" border>
          <el-table-column :label="$t('message.orderNumber')" align="center" min-width="170">
            <template slot-scope="scope">
              <router-link :to="`/orderPaymentDetail?order_sn=${scope.row.order_sn}`" target="_blank" class="a-link">
                {{ scope.row.order_sn || '-' }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.mash')" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.sorting || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('message.productManagementNumber')" align="center" min-width="140">
            <template slot-scope="scope">{{ scope.row.for_sn || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('message.productPicture')" align="center" width="110">
            <template slot-scope="scope">
              <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="cover" class="goods-img"
                :preview-src-list="[scope.row.pic]" />
              <div v-else class="empty-img"></div>
            </template>
          </el-table-column>
          <el-table-column label="SKU" align="center" min-width="150">
            <template slot-scope="scope">
              <div class="cell-lines">
                <p v-for="(item, index) in getSku(scope.row)" :key="index">{{ item }}</p>
                <p v-if="!getSku(scope.row).length">-</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.additionalServices')" align="center" min-width="180">
            <template slot-scope="scope">
              <div class="cell-lines">
                <p v-for="(item, index) in getOptions(scope.row)" :key="index">{{ item }}</p>
                <p v-if="!getOptions(scope.row).length">-</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.remark')" align="center" min-width="180">
            <template slot-scope="scope">{{ getRemark(scope.row) }}</template>
          </el-table-column>
          <!-- 数量：可入库、已到货、已出货 -->
          <el-table-column :label="$t('message.quantity')" align="center" min-width="130">
            <template slot-scope="scope">
              <div>{{ $t('message.canBePutIntoStorage') }}：{{ scope.row.storage_num }}</div>
              <div>{{ $t('message.itHasArrived') }}：{{ scope.row.storage_num }}</div>
              <div>{{ $t('message.shipped') }}：{{ scope.row.delivery_num }}</div>
            </template>
          </el-table-column>
          <!-- 已标识商品的库位直接使用当前行 stock_grids，仅展示有数量的库位 -->
          <el-table-column :label="$t('message.location')" align="center" min-width="160">
            <template slot-scope="scope">
              <div class="material-stock-grids">
                <div v-for="(grid, index) in scope.row.stock_grids" :key="index">
                  {{ getStockGridNumber(grid.grid_number) }}（{{ grid.num }}）
                </div>
                <span v-if="!scope.row.stock_grids.length">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.operation')" align="center" width="100">
            <template slot-scope="scope">
              <!-- 解除辅料标识：二次确认后调用 sortingNotSignMaterial，并刷新当前页数据 -->
              <el-button v-if="isAuth(670)" size="mini" @click="sortingNotSignMaterial(scope.row)">{{
                $t('message.unmark') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationContainer">
          <el-pagination @size-change="handleOrderSizeChange" @current-change="handleOrderCurrentChange"
            :current-page="orderPage.page" :page-sizes="[10, 20, 50]" :page-size="orderPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="orderTotal" />
        </div>
      </div>

      <!-- 订单绑定辅料使用：展示订单商品绑定当前辅料后的预计消耗与可用数量 -->
      <div class="section">
        <div class="section-title">{{ $t('message.orderBindMaterialUsage') }}</div>
        <div class="border"></div>
        <el-table v-loading="bindOrderLoading" :data="bindOrderList" :header-cell-style="{ background: '#EDEFF4' }"
          border>
          <!-- 订单号 -->
          <el-table-column :label="$t('message.orderNumber')" align="center" min-width="170">
            <template slot-scope="scope">
              <router-link :to="`/orderPaymentDetail?order_sn=${scope.row.order_sn}`" target="_blank" class="a-link">
                {{ scope.row.order_sn || '-' }}
              </router-link>
            </template>
          </el-table-column>
          <!-- 序号 -->
          <el-table-column label="NO" type="index" align="center" width="70" />
          <!-- 商品管理番号 -->
          <el-table-column :label="$t('message.productManagementNumber')" align="center" min-width="150">
            <template slot-scope="scope">{{ scope.row.for_sn || '-' }}</template>
          </el-table-column>
          <!-- 商品图片 -->
          <el-table-column :label="$t('message.productPicture')" align="center" width="110">
            <template slot-scope="scope">
              <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="cover" class="goods-img"
                :preview-src-list="[scope.row.pic]" />
              <div v-else class="empty-img"></div>
            </template>
          </el-table-column>
          <!-- SKU -->
          <el-table-column label="SKU" align="center" min-width="150">
            <template slot-scope="scope">
              <div class="cell-lines">
                <p v-for="(item, index) in getSku(scope.row)" :key="index">{{ item }}</p>
                <p v-if="!getSku(scope.row).length">-</p>
              </div>
            </template>
          </el-table-column>
          <!-- 附加服务 -->
          <el-table-column :label="$t('message.additionalServices')" align="center" min-width="180">
            <template slot-scope="scope">
              <div class="cell-lines">
                <p v-for="(item, index) in getOptions(scope.row)" :key="index">{{ item }}</p>
                <p v-if="!getOptions(scope.row).length">-</p>
              </div>
            </template>
          </el-table-column>
          <!-- 实际购买数 -->
          <el-table-column :label="$t('message.actualPurchaseQuantity')" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.possible_num }}</template>
          </el-table-column>
          <!-- 已出库数 -->
          <el-table-column :label="$t('message.shippedQuantity')" align="center" width="110">
            <template slot-scope="scope">{{ scope.row.delivery_num }}</template>
          </el-table-column>
          <!-- 预计可用数 -->
          <el-table-column :label="$t('message.estimatedAvailableQuantity')" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.storage_num }}</template>
          </el-table-column>
          <!-- 每套消耗点数 -->
          <el-table-column :label="$t('message.consumptionPerSet')" align="center" width="130">
            <template slot-scope="scope">{{ scope.row.consume }} {{ $t('message.pointsPerSet') }}</template>
          </el-table-column>
          <!-- 预计消耗点数 -->
          <el-table-column :label="$t('message.estimatedConsumptionPoints')" align="center" width="140">
            <template slot-scope="scope">{{ scope.row.consume * scope.row.possible_num }}</template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column :label="$t('message.operation')" align="center" width="120">
            <template slot-scope="scope">
              <!-- 解除绑定：按订单详情 ID 解绑当前辅料 -->
              <el-button size="mini" @click="unbindMaterial(scope.row)">{{ $t('message.unbindMaterial') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationContainer">
          <el-pagination @size-change="handleBindOrderSizeChange" @current-change="handleBindOrderCurrentChange"
            :current-page="bindOrderPage.page" :page-sizes="[10, 20, 50]" :page-size="bindOrderPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="bindOrderTotal" />
        </div>
      </div>

      <div class="content-row">
        <!-- 库存信息 -->
        <div class="stock-panel">
          <div class="section-title">{{ $t('message.stockInfo') }}</div>
          <div class="stock-card orange">
            <div class="stock-icon"><img src="@/assets/icon/inventoryQuantity.png" alt=""></div>
            <div>
              <p>{{ $t('message.actualStockQuantity') }}</p>
              <strong>{{ formatNum(detail.material_stock_num) }}</strong>
              <span class="stock-status" :class="stockStatus.type">{{ stockStatus.text }}</span>
            </div>
          </div>
          <div class="stock-card red">
            <div class="stock-icon"><img src="@/assets/icon/consumptionQuantity.png" alt=""></div>
            <div>
              <p>{{ $t('message.expectedConsumptionQuantity') }}</p>
              <strong>{{ formatNum(detail.pre_consume_num) }}</strong>
            </div>
          </div>
          <div class="stock-card green">
            <div class="stock-icon"><img src="@/assets/icon/replenishmentQuantity.png" alt=""></div>
            <div>
              <p>{{ $t('message.expectedReplenishmentQuantity') }}</p>
              <strong>{{ formatNum(detail.pre_up_num) }}</strong>
            </div>
          </div>
        </div>

        <!-- 系统自动使用记录 -->
        <div class="record-panel">
          <div class="section-title">{{ $t('message.systemAutomaticUsageRecord') }}</div>
          <el-table :data="recordPageList" :header-cell-style="{ background: '#EDEFF4' }"
            :row-class-name="getUsageRecordRowClass" border>
            <el-table-column label="NO" type="index" align="center" width="70" />
            <el-table-column :label="$t('message.recordTime')" align="center" width="180">
              <template slot-scope="scope">{{ scope.row.created_at || scope.row.datetime || '-' }}</template>
            </el-table-column>
            <el-table-column :label="$t('message.consumptionDetail')" align="center" min-width="300">
              <template slot-scope="scope">
                <p>
                  <b>{{ $t('message.porderSn') }}</b>： <router-link
                    :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" target="_blank">
                    {{ scope.row.porder_sn }}
                  </router-link>
                </p>
                <p>{{ isUsageConsume(scope.row) ? $t('message.consumedPoints') : $t('message.returnedToWarehouse')
                  }}：<span :class="isUsageConsume(scope.row) ? 'record-num consume' : 'record-num other'">{{
                    scope.row.num }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('message.type')" align="center" width="110">
              <template slot-scope="scope">
                {{ scope.row.type_name }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('message.quantity')" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.num || scope.row.quantity || '-' }}</template>
            </el-table-column>
          </el-table>
          <div class="paginationContainer">
            <el-pagination @size-change="handleRecordSizeChange" @current-change="handleRecordCurrentChange"
              :current-page="recordPage.page" :page-sizes="[10, 20, 50]" :page-size="recordPage.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="recordList.length" />
          </div>
        </div>
      </div>

      <!-- 其他信息：注意事项单独保存，不影响基础信息和媒体字段 -->
      <div class="section">
        <div class="notice-title">
          <div class="section-title">{{ $t('message.otherInfo') }}</div>
          <el-button type="primary" size="mini" :loading="noticeLoading" @click="updateNotice">{{ $t('message.save')
            }}</el-button>
        </div>
        <div class="border"></div>
        <el-input v-model="noticeForm.notice" type="textarea" :rows="5"
          :placeholder="$t('message.pleaseEnterMattersNeedingAttention')" />
      </div>
    </div>
    <!-- 主图放大预览：仅展示当前 main_image，不修改数据 -->
    <el-dialog :visible.sync="mainImagePreviewVisible" width="680px" append-to-body>
      <img v-if="detail.main_image" :src="detail.main_image" class="main-preview-img">
    </el-dialog>
    <!-- 单独修改辅料译文名：name 与 name_trans 提交相同值 -->
    <el-dialog :title="$t('message.editMaterialName')" :visible.sync="nameDialogVisible" width="460px" append-to-body>
      <el-form label-width="90px">
        <el-form-item :label="$t('message.materialNameTrans')">
          <el-input v-model.trim="nameForm.name_trans" :placeholder="$t('message.pleaseTranslationName')" />
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button @click="nameDialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button type="primary" :loading="nameLoading" @click="updateName">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量绑定候选弹框：当前只接候选列表和选择事件，保存接口待后端提供。 -->
    <batch-bind-order-plan-dialog ref="batchBindOrderPlanDialog" @saved="loadBoundOrderPlanList" />
  </div>
</template>

<script>
import detailHeader from '@/components/header/detailHeader'
import BatchBindOrderPlanDialog from './components/batchBindOrderPlanDialog.vue'

export default {
  name: 'MaterialDetail',
  components: {
    detailHeader,
    BatchBindOrderPlanDialog
  },
  data() {
    return {
      loading: false, // 页面详情加载状态
      mediaLoading: false, // 主图、详情图、资料文件上传/保存状态
      mainImagePreviewVisible: false, // 主图放大预览弹框
      nameDialogVisible: false, // 修改辅料名称弹框
      nameLoading: false, // 名称保存按钮 loading
      noticeLoading: false, // 注意事项保存按钮 loading
      bindOrderLoading: false, // 订单绑定辅料使用列表 loading
      detail: {}, // 辅料详情主体数据
      images: [], // 详情图列表，独立于 detail 保存
      files: [], // 资料文件列表，独立于 detail 保存
      nameForm: {
        name_trans: ''
      },
      // 注意事项表单：单独保存 notice 字段
      noticeForm: {
        notice: ''
      },
      orderLoading: false, // 已标识商品列表 loading
      orderList: [], // 已标识商品列表，接口分页展示
      orderTotal: 0, // 已标识商品总数
      recordList: [], // 预估自动消耗记录完整数据，接口一次取 1000 条后前端分页
      bindOrderList: [], // 订单绑定辅料使用列表，接口分页展示
      bindOrderTotal: 0, // 订单绑定辅料使用总数
      boundOrderPlanLoading: false, // 已绑定商品管理番号及下单方案列表 loading
      boundOrderPlanList: [], // 已绑定商品管理番号及下单方案列表
      // 已标识商品分页参数
      orderPage: {
        page: 1,
        pageSize: 10
      },
      // 预估自动消耗记录分页参数
      recordPage: {
        page: 1,
        pageSize: 10
      },
      // 订单绑定辅料使用分页参数
      bindOrderPage: {
        page: 1,
        pageSize: 10
      },
      // 已绑定商品管理番号分页参数
      boundOrderPlanPage: {
        page: 1,
        // 固定区域内滚动展示，单次读取足量管理番号
        pageSize: 999
      }
    }
  },
  computed: {
    // 消耗记录当前页数据
    recordPageList() {
      const start = (this.recordPage.page - 1) * this.recordPage.pageSize
      return this.recordList.slice(start, start + this.recordPage.pageSize)
    },
    // 库存状态：无库存（数量为0）> 数量充足（实际库存 > 预计消耗）> 建议补货（实际库存 < 预计消耗且不为0）
    stockStatus() {
      const stockNum = Number(this.detail.material_stock_num || 0)
      const consumeNum = Number(this.detail.pre_consume_num || 0)
      // 辅料数量为 0：无库存
      if (stockNum === 0) {
        return {
          text: this.$t('message.noStock'),
          type: 'danger'
        }
      }
      // 实际库存大于预计消耗数：数量充足
      if (stockNum > consumeNum) {
        return {
          text: this.$t('message.stockSufficient'),
          type: 'success'
        }
      }
      // 实际库存小于预计消耗数且不为 0：建议补货
      return {
        text: this.$t('message.suggestReplenishment'),
        type: 'warning'
      }
    }
  },
  created() {
    this.materialDetail()
  },
  methods: {
    // 查询辅料详情，后端要求 user_id，这里同时携带 id 以便定位当前辅料
    materialDetail() {
      const datas = {
        user_id: this.$route.query.user_id || ''
      }
      if (this.$route.query.id) datas.id = this.$route.query.id
      this.loading = true
      this.$api.warehouseApi.materialDetail(datas).then(res => {
        const data = res.data || {}
        // 兼容详情接口可能返回 material/detail/扁平对象三种结构
        this.detail = data.material || data.detail || data
        // 媒体字段后端可能返回 JSON 字符串或对象数组，统一转成 URL 数组供组件渲染
        this.images = this.normalizeFileList(this.detail.images || this.detail.image_list || [])
        this.files = this.normalizeFileList(this.detail.files || this.detail.file_list || [])
        this.noticeForm.notice = this.detail.notice || ''
        // 已标识商品使用独立接口，详情加载完成后按当前辅料 id 拉取
        this.signOrderDetailList()
        // 消耗记录使用独立接口，详情加载完成后再用当前辅料 id 拉取
        this.porderUsageLogList()
        // 订单绑定辅料使用使用独立分页接口，按当前辅料主档 ID 拉取
        this.bindOrderDetailList()
        // 已绑定商品管理番号及其下单方案使用独立分页接口
        this.loadBoundOrderPlanList()
      }).finally(() => {
        this.loading = false
      })
    },
    // 辅料标识的订单详情列表：后端分页，参数为辅料主档 id、page、pageSize
    signOrderDetailList() {
      const datas = {
        id: this.detail.id || this.$route.query.id,
        page: this.orderPage.page,
        pageSize: this.orderPage.pageSize
      }
      if (!datas.id) return
      this.orderLoading = true
      this.$api.warehouseApi.signOrderDetailList(datas).then(res => {
        const data = res.data || {}
        // 库位随已标识商品列表返回，不额外查询库存接口
        this.orderList = (data.data || data.list || []).map(item => ({
          ...item,
          stock_grids: (item.stock_grids || []).filter(grid => Number(grid.num) > 0)
        }))
        this.orderTotal = data.total || 0
      }).finally(() => {
        this.orderLoading = false
      })
    },
    // 预估自动消耗记录：按当前辅料单独拉取配送单消耗/回退历史
    porderUsageLogList() {
      const datas = {
        user_id: this.detail.user_id || this.$route.query.user_id || '',
        material_id: this.detail.id || this.$route.query.id,
        pageSize: 1000
      }
      if (!datas.material_id) return
      this.$api.warehouseApi.porderUsageLogList(datas).then(res => {
        const data = res.data || {}
        // 接口结构未固定时，兼容 list/records/data.list/data.records/data.data 等常见返回
        const list = Array.isArray(data)
          ? data
          : data.list || data.records || (data.data && (data.data.list || data.data.records || data.data.data)) || data.data || []
        this.recordList = Array.isArray(list) ? list : (list && Array.isArray(list.data) ? list.data : [])
        this.recordPage.page = 1
      })
    },
    // 与订单、核查辅料展示一致，只保留部门前缀“】-”之后的库位编号
    getStockGridNumber(gridNumber) {
      if (!gridNumber) return ''
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    },
    // 订单绑定辅料使用列表：后端分页，参数为辅料主档 id、page、pageSize
    bindOrderDetailList() {
      const datas = {
        id: this.detail.id || this.$route.query.id,
        page: this.bindOrderPage.page,
        pageSize: this.bindOrderPage.pageSize
      }
      if (!datas.id) return
      this.bindOrderLoading = true
      this.$api.warehouseApi.bindOrderDetailList(datas).then(res => {
        const data = res.data || {}
        this.bindOrderList = data.data || []
        this.bindOrderTotal = data.total || 0
      }).finally(() => {
        this.bindOrderLoading = false
      })
    },
    // 已绑定商品管理番号及下单方案列表：后端按管理番号分页
    loadBoundOrderPlanList() {
      const datas = {
        id: this.detail.id || this.$route.query.id,
        page: this.boundOrderPlanPage.page,
        pageSize: this.boundOrderPlanPage.pageSize
      }
      if (!datas.id) return
      this.boundOrderPlanLoading = true
      this.$api.warehouseApi.boundOrderPlanList(datas).then(res => {
        this.boundOrderPlanList = res.data.data || []
      }).finally(() => {
        this.boundOrderPlanLoading = false
      })
    },
    // 新标签打开商品管理列表，并默认按当前管理番号查询
    openBoundProduct(row) {
      const route = this.$router.resolve({
        name: 'productManagementV2',
        query: {
          client_sku_code: row.client_sku_code
        }
      })
      window.open(route.href, '_blank')
    },
    // 打开批量绑定候选弹框，弹框内部按当前辅料 ID 查询管理番号分页数据。
    openBatchBindOrderPlanDialog() {
      this.$refs.batchBindOrderPlanDialog.open(this.detail.id || this.$route.query.id)
    },
    // 解除订单绑定辅料使用：list[订单详情ID][0] 为当前辅料 ID
    unbindMaterial(row) {
      this.$confirm(this.$t('message.confirmUnbindMaterial'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning'
      }).then(() => {
        const orderDetailId = row.order_detail_id || row.id
        const datas = {
          user_id: this.detail.user_id || this.$route.query.user_id || '',
          list: {
            [orderDetailId]: [this.detail.id || this.$route.query.id]
          }
        }
        this.$api.warehouseApi.sortingUnbindMaterial(datas).then(res => {
          this.$message.success(res.msg)
          this.materialDetail()
        })
      }).catch(() => { })
    },
    // 上传主图，主图只修改 main_image 字段
    async uploadMainImage(file) {
      this.mediaLoading = true
      try {
        // createClient 为全局上传方法，返回 OSS 地址后立即保存到 main_image
        const data = await this.createClient(file)
        this.$set(this.detail, 'main_image', data.data)
        await this.updateMainImage()
      } finally {
        this.mediaLoading = false
      }
    },
    // 上传详情图，新增后保存 images 数组
    async uploadImages(file) {
      this.mediaLoading = true
      try {
        // 详情图追加上传结果后，提交完整 images 数组，避免覆盖已有图片
        const data = await this.createClient(file)
        this.images.push(data.data)
        await this.updateImages()
      } finally {
        this.mediaLoading = false
      }
    },
    // 上传资料文件，新增后保存 files 数组
    async uploadFiles(file) {
      this.mediaLoading = true
      try {
        // 资料文件追加上传结果后，提交完整 files 数组，避免覆盖已有文件
        const data = await this.createClient(file)
        this.files.push(data.data)
        await this.updateFiles()
      } finally {
        this.mediaLoading = false
      }
    },
    // 删除详情图，保存删除后的 images 数组
    removeImage(index) {
      this.$confirm(this.$t('message.confirmDeleteMaterialImage'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        center: true,
      }).then(() => {
        this.images.splice(index, 1)
        this.updateImages()
      }).catch(() => {
      })
    },
    // 删除资料文件，保存删除后的 files 数组
    removeFile(index) {
      this.$confirm(this.$t('message.confirmDeleteMaterialFile'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        center: true,
      }).then(() => {
        this.files.splice(index, 1)
        this.updateFiles()
      }).catch(() => {
      })
    },
    // 媒体字段共用的基础参数
    getMaterialParams() {
      return {
        // 媒体、名称、注意事项接口都需要同一组定位参数
        id: this.detail.id || this.$route.query.id,
        user_id: this.detail.user_id || this.$route.query.user_id || ''
      }
    },
    // 单独修改主图，只提交 main_image
    updateMainImage() {
      const datas = {
        ...this.getMaterialParams(),
        main_image: this.detail.main_image || ''
      }
      return this.$api.warehouseApi.updateMainImage(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 单独修改详情图，只提交 images 数组
    updateImages() {
      const datas = {
        ...this.getMaterialParams(),
        images: this.images
      }
      return this.$api.warehouseApi.updateImages(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 单独修改文件，只提交 files 数组
    updateFiles() {
      const datas = {
        ...this.getMaterialParams(),
        files: this.files
      }
      return this.$api.warehouseApi.updateFiles(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 打开辅料译文名称修改弹框
    openNameDialog() {
      this.nameForm = {
        name_trans: this.detail.name_trans || ''
      }
      this.nameDialogVisible = true
    },
    // 修改译文名称时，接口的 name 与 name_trans 提交相同值
    updateName() {
      if (!this.nameForm.name_trans) return this.$message.error(this.$t('message.pleaseTranslationName'))

      const datas = {
        id: this.detail.id || this.$route.query.id,
        user_id: this.detail.user_id || this.$route.query.user_id || '',
        name: this.nameForm.name_trans,
        name_trans: this.nameForm.name_trans
      }
      this.nameLoading = true
      this.$api.warehouseApi.updateName(datas).then(res => {
        this.$set(this.detail, 'name', this.nameForm.name_trans)
        this.$set(this.detail, 'name_trans', this.nameForm.name_trans)
        this.nameDialogVisible = false
        this.$message.success(res.msg)
      }).finally(() => {
        this.nameLoading = false
      })
    },
    // 单独修改注意事项，只提交 notice
    updateNotice() {
      if (!this.noticeForm.notice) return this.$message.error(this.$t('message.pleaseEnterMattersNeedingAttention'))
      const datas = {
        id: this.detail.id || this.$route.query.id,
        user_id: this.detail.user_id || this.$route.query.user_id || '',
        notice: this.noticeForm.notice
      }
      this.noticeLoading = true
      this.$api.warehouseApi.updateNotice(datas).then(res => {
        this.$set(this.detail, 'notice', this.noticeForm.notice)
        this.$message.success(res.msg)
      }).finally(() => {
        this.noticeLoading = false
      })
    },
    // 限制图片上传类型，避免文件误传到图片字段
    beforeImageUpload(file) {
      const typeList = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/bmp']
      const isImage = typeList.includes(file.type)
      if (!isImage) this.$message.error(this.$t('message.pleaseUploadImage'))
      return isImage
    },
    // 文件列表归一化：兼容 JSON 字符串、URL 数组、对象数组
    normalizeFileList(list) {
      if (!list) return []
      if (typeof list === 'string') {
        try {
          const arr = JSON.parse(list)
          if (Array.isArray(arr)) return this.normalizeFileList(arr)
        } catch (error) {
          return list ? [list] : []
        }
      }
      if (!Array.isArray(list)) return []
      return list.map(item => {
        if (typeof item === 'string') return item
        return item.url || item.path || item.image || item.file || item.file_url || item.main_image || ''
      }).filter(Boolean)
    },
    // 已标识商品解除辅料标识，接口参数 orderDetailIds[0]
    sortingNotSignMaterial(row) {
      if (!this.isAuth(670)) return
      const orderDetailId = row.order_detail_id || row.id
      if (!orderDetailId) return
      this.$confirm(this.$t('message.confirmUnmarkMaterial'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.warehouseApi.sortingNotSignMaterial({
          orderDetailIds: [orderDetailId]
        }).then(res => {
          this.$message.success(res.msg)
          this.materialDetail()
        })
      }).catch(() => { })
    },
    // SKU 明细兼容 detail_y/detail 两种字段
    getSku(row) {
      const detail = row.detail_y && row.detail_y.length ? row.detail_y : row.detail
      if (!detail || !detail.length) return []
      return detail.map(item => `${item.key || ''}${item.value ? '：' + item.value : ''}`)
    },
    // 附加服务拼接名称、数量和金额，表格中按多行展示
    getOptions(row) {
      if (!row.option || !row.option.length) return []
      return row.option.map(item => {
        const num = item.num ? `*${item.num}` : ''
        const price = item.price ? ` ${item.price}${item.unit || ''}` : ''
        return `${item.name || ''}${num}${price}`
      })
    },
    // 备注按业务、客户、采购、配货的常见字段顺序兜底
    getRemark(row) {
      return row.y_remark || row.client_remark || row.g_remark || row.p_remark || '-'
    },
    // 系统自动使用记录：消耗行用红色，回退/其他类型用绿色
    isUsageConsume(row) {
      return row.type !== 'return'
    },
    // 系统自动使用记录表格行背景色，背景透明度按 50% 展示
    getUsageRecordRowClass({ row }) {
      return this.isUsageConsume(row) ? 'usage-record-consume-row' : 'usage-record-other-row'
    },
    // 从 OSS 地址中截取文件名，并将编码后的中文文件名转回中文
    getFileName(url) {
      const fileName = ((url || '').split('/').pop() || url).split('?')[0]
      try {
        return decodeURIComponent(fileName)
      } catch (error) {
        return fileName
      }
    },
    formatNum(num) {
      return num != null && num !== '' ? num : '-'
    },
    // 已标识商品切换页码
    handleOrderCurrentChange(val) {
      this.orderPage.page = val
      this.signOrderDetailList()
    },
    // 已标识商品切换每页条数，并回到第一页
    handleOrderSizeChange(val) {
      this.orderPage.pageSize = val
      this.orderPage.page = 1
      this.signOrderDetailList()
    },
    // 消耗记录切换页码
    handleRecordCurrentChange(val) {
      this.recordPage.page = val
    },
    // 消耗记录切换每页条数，并回到第一页
    handleRecordSizeChange(val) {
      this.recordPage.pageSize = val
      this.recordPage.page = 1
    },
    // 订单绑定辅料使用切换页码
    handleBindOrderCurrentChange(val) {
      this.bindOrderPage.page = val
      this.bindOrderDetailList()
    },
    // 订单绑定辅料使用切换每页条数，并回到第一页
    handleBindOrderSizeChange(val) {
      this.bindOrderPage.pageSize = val
      this.bindOrderPage.page = 1
      this.bindOrderDetailList()
    }
  }
}
</script>

<style lang="scss" scoped>
.material-detail-root {
  min-height: 100vh;
  background: #fff;
}

.material-detail-page {
  min-height: calc(100vh - 50px);
  min-width: 1910px;
  padding: 20px;
  background: #fff;
  color: #333;
  box-sizing: border-box;
}

.section {
  margin-bottom: 18px;
  padding: 16px;
  background: #f8f8f8;
  box-sizing: border-box;
}

.section-title {
  margin-bottom: 14px;
  font-size: 20px;
  font-weight: 700;
}

.info-body {
  display: flex;
  gap: 16px;
}

.material {

  flex: 1;

}

.material-left {
  display: flex;

}

.main-image {
  flex: 0 0 150px;
  width: 150px;
  margin-right: 12px;
}

.main-media,
.main-upload {
  width: 150px;
  height: 150px;
}

.main-media {
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, .08);

  &:hover {
    .main-image-mask {
      opacity: 1;
    }
  }
}

.main-change-upload {
  /deep/ .el-upload {
    display: block;
  }
}

.main-image-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(0, 0, 0, .28);
  opacity: 0;
  pointer-events: none;
  transition: opacity .2s;
}

.main-image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  color: #fff;
  background: rgba(0, 0, 0, .5);
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;
  transition: background .2s;

  &:hover {
    background: rgba(0, 0, 0, .68);
  }

  i {
    font-size: 22px;
  }
}

.material-info {
  flex: 1;
  min-width: 0;
}

.name-row,
.sub-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
}

.type-tag {
  padding: 5px 8px;
  color: #2c96e7;
  background: #ebf2ff;
  border-radius: 4px;
}

.name {
  font-weight: 600;
}

.name-trans {
  color: #666;
}

.name-edit-icon {
  color: #b4272d;
  cursor: pointer;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.thumb,
.thumb-upload {
  width: 70px;
  height: 70px;
}

.media-item {
  position: relative;
  background: #d8d8d8;



  .el-image {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}

.delete-icon {
  position: absolute;
  top: -7px;
  right: -7px;
  z-index: 2;
  color: #d9363e;
  font-size: 20px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
}

.upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #fff;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;

  i {
    color: #18af49;
    font-size: 18px;
  }

  p {
    margin: 6px 0 0;
    font-size: 12px;
  }
}

.file-area {
  flex: 1;
  padding-left: 42px;
  border-left: 1px solid #DCDFE6;
}

.bound-order-plan-area {
  flex: 1;
  min-width: 360px;
  padding-left: 42px;
  border-left: 1px solid #DCDFE6;
}

.bound-order-plan-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  .section-title {
    margin-bottom: 0;
  }
}

.bound-order-plan-table {
  height: 180px;
  overflow: hidden;
}

// 方案内容随表格行展开，滚动统一由 el-table 处理
.bound-plan-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 28px;
  line-height: 20px;

  & + & {
    border-top: 1px solid #EBEEF5;
  }
}

.bound-plan-consume {
  flex: 0 0 auto;
}

.bound-plan-consume-value {
  color: #b4272d;
}

.file-title {
  margin-bottom: 12px;
  font-weight: 600;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.file-card {
  position: relative;
  width: 150px;
  height: 150px;

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 8px;
    color: #666;
    text-decoration: none;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    box-sizing: border-box;
  }

  i {
    color: #2c96e7;
    font-size: 34px;
  }

  span {
    display: -webkit-box;
    width: 100%;
    height: 48px;
    margin-top: 8px;
    overflow: hidden;
    line-height: 16px;
    word-break: break-all;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }

  .delete-icon {
    color: #d9363e;
    font-size: 20px;
  }
}

.file-upload {
  width: 150px;
  height: 150px;
  border-radius: 6px;
}

.main-preview-img {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
  border-radius: 6px;
}

.goods-img,
.empty-img {
  width: 60px;
  height: 60px;
  background: #d8d8d8;
}

.cell-lines {
  max-height: 90px;
  overflow: hidden;
  line-height: 20px;

  p {
    margin: 0;
  }
}

// 库位逐行展示，长编号允许换行，避免挤压相邻数量列
.material-stock-grids {
  min-height: 24px;
  line-height: 24px;
  word-break: break-all;
}

.content-row {
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
  background-color: #f8f8f8;
}

.stock-panel,
.record-panel {
  padding: 16px;

  box-sizing: border-box;
}

.stock-panel {
  flex: 0 0 260px;
}

.record-panel {
  flex: 1;
  min-width: 0;
}

.stock-card {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
  padding: 14px;
  background: #fff !important;
  border-radius: 4px;

  p {
    margin: 0 0 6px;
    color: #666;
  }

  strong {
    display: block;
    margin-bottom: 6px;
    font-size: 34px;
  }

  .stock-status {
    display: inline-block;
    min-width: 96px;
    padding: 8px 16px;
    color: #15ad3c;
    text-align: center;
    background: #e9f7ed;
    border-radius: 4px;

    &.warning {
      color: #ff8a00;
      background: #fff4e5;
    }

    &.danger {
      color: #b4272d;
      background: #f8eded;
    }

    &.success {
      color: #15ad3c;
      background: #e9f7ed;
    }
  }

  &.orange strong,
  &.orange .stock-icon {
    color: #ff8a00;
  }

  &.red strong,
  &.red .stock-icon {
    color: #d9363e;
    background-color: #fff !important;
  }

  &.green strong,
  &.green .stock-icon {
    color: #15ad3c;
  }
}

.stock-icon {
  flex: 0 0 42px;
  font-size: 34px;

}

.record-detail {
  padding: 8px;
  color: #b4272d;
  background: #fff1f0;
  text-align: left;

  &.plus {
    color: #15ad3c;
    background: #eefaf1;
  }

  p {
    margin: 0;
    line-height: 20px;
  }
}

.record-panel {
  /deep/ .usage-record-consume-row td {
    background: rgba(217, 54, 62, .5) !important;
  }

  /deep/ .usage-record-other-row td {
    background: rgba(21, 173, 60, .5) !important;
  }

  .record-num {
    font-weight: 600;

    &.consume {
      color: #b4272d;
    }

    &.other {
      color: #0f8f34;
    }
  }
}

.a-link {
  color: #2c96e7;
}

.paginationContainer {
  margin-top: 14px;
  text-align: center;
}

.notice-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 1100px) {

  .info-body,
  .content-row {
    flex-wrap: wrap;
  }

  .file-area,
  .stock-panel,
  .record-panel {
    flex: 1 1 100%;
  }


}

.border {
  width: 100%;
  height: 1px;
  background-color: #DCDFE6;
  margin-bottom: 20px;
}
</style>
